import QueryContainer from './QueryContainer';
import QueryView from './QueryView';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

export { QueryView, QueryContainer };


// import { providers } from '../../store/spottingGroup/spottingGroupReducers';
const providers = {};

// by default we only pull in the user state - expand as needed
const mapStateToProps = (state = {}) => ({
  ...state.users,
});

const mapDispatchToProps = () => ({});
/*
dispatch => Object.keys(providers)
.reduce((dispatcher, name) => ({ ...dispatcher, [name]: (...args) => dispatch(providers[name](...args)) }), {});
*/

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(QueryContainer));
